<template>
  <div v-if="stats != null">

    <div class="">
      <div class="overflow-hidden">
        <div class="float-left text-2xl">
          Dashboard
        </div>
      </div>
    </div>

    <div class="flex flex-wrap -mx-4">
      <div class="w-1/6 p-4">
        <div class="border shadow-lg rounded-lg p-4">
          <div class="text-lg text-blue-500">
            {{ stats.numBrokers }}
          </div>

          <div class="text-sm text-gray-800">
            # Brokers
          </div>
        </div>
      </div>

      <div class="w-1/6 p-4">
        <div class="border shadow-lg rounded-lg p-4">
          <div class="text-lg text-blue-500">
            {{ stats.numClients }}
          </div>

          <div class="text-sm text-gray-800">
            # Clients
          </div>
        </div>
      </div>

      <div class="w-1/6 p-4">
        <div class="border shadow-lg rounded-lg p-4">
          <div class="text-lg text-blue-500">
            {{ stats.numEmails }}
          </div>

          <div class="text-sm text-gray-800">
            # Emails sent
          </div>
        </div>
      </div>

      <div class="w-1/6 p-4">
        <div class="border shadow-lg rounded-lg p-4">
          <div class="text-lg text-blue-500">
            {{ stats.numStripeCustomers }}
          </div>

          <div class="text-sm text-gray-800">
            # Stripe paying brokers
          </div>
        </div>
      </div>

      <div class="w-1/6 p-4">
        <div class="border shadow-lg rounded-lg p-4">
          <div class="text-lg text-blue-500">
            {{ stats.numMercuryBrokers }}
          </div>

          <div class="text-sm text-gray-800">
            # Mercury brokers
          </div>
        </div>
      </div>

      <!-- <div class="w-1/6 p-4">
        <div class="border shadow-lg rounded-lg p-4">
          <div class="text-lg text-blue-500">
            {{ stats.numActiveBrokers }}
          </div>

          <div class="text-sm text-gray-800">
            # Brokers who logged in last 30 days
          </div>
        </div>
      </div> -->
    </div>
  </div>
</template>

<script>

  // import axios        from "axios";
  // import BrokerList   from "./BrokerList"
  // import { EventBus } from '@/shared/event-bus';

  export default {

    // components: {
    //   BrokerList,
    // },

    data() {
      return {
        // query     : null,
        // broker    : _.cloneDeep(this.$store.state.brokerModule.broker),
        stats: null,
        // chartData : null,
        // activities: null
      }
    },

    created() {
      // get some stats
      this.apiGet({}, 'dashboard/stats', (stats) => {
        this.stats = stats
      })
    }

    // methods: {
    //   exportAsCsv() {
    //     this.showLoader("Exporting...")
    //     axios.get(process.env.VUE_APP_API_URL + '/api/broker/export', {
    //       responseType: 'blob',
    //       headers: {
    //         'Authorization' : 'Bearer ' + localStorage.getItem('bp-broker-jwt')
    //       }
    //     }).then(response => {

    //        this.hideLoader();
    //        const url    = window.URL.createObjectURL(new Blob([response.data]));
    //        const link   = document.createElement('a');
    //        link.href    = url;
    //        link.setAttribute('download', 'brokerpad_brokers.csv'); //or any other extension
    //        document.body.appendChild(link);
    //        link.click();

    //        EventBus.$emit('notification-event', {
    //         'type'   : 'success',
    //         'message': 'CSV is successfully exported!.'
    //       });
    //     })
    //     .catch(e => {
    //       this.hideLoader();
    //     })
    //   }

    // }
  }
</script>
